export const APP_CONSTANTS = {
    VERSION: 'V 11.3.0',   // Build at 01-07-2025
    PRODUCT_NAME: 'Integrata',
    LOGO: 'assets/images/logo/logo.svg'
};
